import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensureSession } from '../lib/session';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const state = await ensureSession(context.queryClient);
    if (state.status === 'authenticated') {
      throw redirect({ to: '/chat' });
    }
    throw redirect({ to: '/signin' });
  },
});
